'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ShareScriptureButtonProps {
  verse: string;
  reference: string;
}

const ShareScriptureButton = ({ verse, reference }: ShareScriptureButtonProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [showCopied, setShowCopied] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <button className="px-4 py-2 bg-surface rounded-lg opacity-50 cursor-not-allowed">
        <Icon name="ShareIcon" size={16} className="text-muted" />
      </button>
    );
  }

  const handleShare = async () => {
    const shareText = `"${verse}" - ${reference}`;
    
    try {
      await navigator.clipboard.writeText(shareText);
      setShowCopied(true);
      setTimeout(() => setShowCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={handleShare}
        className="px-4 py-2 bg-surface hover:bg-primary/10 rounded-lg transition-all duration-200 flex items-center space-x-2 group"
        aria-label="Share scripture verse"
      >
        <Icon name="ShareIcon" size={16} className="text-muted group-hover:text-primary transition-colors" />
        <span className="font-inter text-xs text-muted group-hover:text-primary transition-colors">
          Share
        </span>
      </button>
      
      {showCopied && (
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-3 py-1.5 bg-success text-success-foreground rounded-lg shadow-lg whitespace-nowrap z-10">
          <p className="font-inter text-xs font-medium">Copied to clipboard!</p>
        </div>
      )}
    </div>
  );
};

export default ShareScriptureButton;